// src/redux/adminSlice.js
import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    data: {},      // 🔥 admin data store here
  },
  reducers: {
    setAdminData: (state, action) => {
      state.data = action.payload; // 🔥 update admin everywhere
    },
  }
});

export const { setAdminData } = adminSlice.actions;
export default adminSlice.reducer;
